import accessible_18dp from './icons/accessible_18dp.svg?react';
import accessible_24dp from './icons/accessible_24dp.svg?react';
import account_circle_18dp from './icons/account_circle_18dp.svg?react';
import account_circle_24dp from './icons/account_circle_24dp.svg?react';
import account_circle_outline_18dp from './icons/account_circle_outline_18dp.svg?react';
import account_circle_outline_24dp from './icons/account_circle_outline_24dp.svg?react';
import add_circle_18dp from './icons/add_circle_18dp.svg?react';
import add_circle_24dp from './icons/add_circle_24dp.svg?react';
import add_circle_outline_18dp from './icons/add_circle_outline_18dp.svg?react';
import add_circle_outline_24dp from './icons/add_circle_outline_24dp.svg?react';
import add_image_18dp from './icons/add_image_18dp.svg?react';
import add_image_24dp from './icons/add_image_24dp.svg?react';
import add_image_outline_18dp from './icons/add_image_outline_18dp.svg?react';
import add_image_outline_24dp from './icons/add_image_outline_24dp.svg?react';
import add_location_18dp from './icons/add_location_18dp.svg?react';
import add_location_24dp from './icons/add_location_24dp.svg?react';
import arrow_back_18dp from './icons/arrow_back_18dp.svg?react';
import arrow_back_24dp from './icons/arrow_back_24dp.svg?react';
import arrow_downward_18dp from './icons/arrow_downward_18dp.svg?react';
import arrow_downward_24dp from './icons/arrow_downward_24dp.svg?react';
import arrow_forward_18dp from './icons/arrow_forward_18dp.svg?react';
import arrow_forward_24dp from './icons/arrow_forward_24dp.svg?react';
import arrow_upward_18dp from './icons/arrow_upward_18dp.svg?react';
import arrow_upward_24dp from './icons/arrow_upward_24dp.svg?react';
import back_18dp from './icons/back_18dp.svg?react';
import back_24dp from './icons/back_24dp.svg?react';
import backspace_18dp from './icons/backspace_18dp.svg?react';
import backspace_24dp from './icons/backspace_24dp.svg?react';
import badge_18dp from './icons/badge_18dp.svg?react';
import badge_24dp from './icons/badge_24dp.svg?react';
import badge_outline_18dp from './icons/badge_outline_18dp.svg?react';
import badge_outline_24dp from './icons/badge_outline_24dp.svg?react';
import bar_chart_18dp from './icons/bar_chart_18dp.svg?react';
import bar_chart_24dp from './icons/bar_chart_24dp.svg?react';
import build_circle_18dp from './icons/build_circle_18dp.svg?react';
import build_circle_24dp from './icons/build_circle_24dp.svg?react';
import building_18dp from './icons/building_18dp.svg?react';
import building_24dp from './icons/building_24dp.svg?react';
import calendar_month_18dp from './icons/calendar_month_18dp.svg?react';
import calendar_month_24dp from './icons/calendar_month_24dp.svg?react';
import calendar_month_outline_18dp from './icons/calendar_month_outline_18dp.svg?react';
import calendar_month_outline_24dp from './icons/calendar_month_outline_24dp.svg?react';
import calendar_today_18dp from './icons/calendar_today_18dp.svg?react';
import calendar_today_24dp from './icons/calendar_today_24dp.svg?react';
import calendar_today_outline_18dp from './icons/calendar_today_outline_18dp.svg?react';
import calendar_today_outline_24dp from './icons/calendar_today_outline_24dp.svg?react';
import category_18dp from './icons/category_18dp.svg?react';
import category_24dp from './icons/category_24dp.svg?react';
import chat_bubble_18dp from './icons/chat_bubble_18dp.svg?react';
import chat_bubble_24dp from './icons/chat_bubble_24dp.svg?react';
import chat_bubble_outline_18dp from './icons/chat_bubble_outline_18dp.svg?react';
import chat_bubble_outline_24dp from './icons/chat_bubble_outline_24dp.svg?react';
import check_18dp from './icons/check_18dp.svg?react';
import check_24dp from './icons/check_24dp.svg?react';
import check_box_24dp from './icons/check_box_24dp.svg?react';
import check_box_outline_24dp from './icons/check_box_outline_24dp.svg?react';
import check_box_unchecked_24dp from './icons/check_box_unchecked_24dp.svg?react';
import check_box_unchecked_outline_24dp from './icons/check_box_unchecked_outline_24dp.svg?react';
import check_circle_18dp from './icons/check_circle_18dp.svg?react';
import check_circle_24dp from './icons/check_circle_24dp.svg?react';
import check_circle_outline_18dp from './icons/check_circle_outline_18dp.svg?react';
import check_circle_outline_24dp from './icons/check_circle_outline_24dp.svg?react';
import chevron_down_18dp from './icons/chevron_down_18dp.svg?react';
import chevron_down_24dp from './icons/chevron_down_24dp.svg?react';
import chevron_left_18dp from './icons/chevron_left_18dp.svg?react';
import chevron_left_24dp from './icons/chevron_left_24dp.svg?react';
import chevron_right_18dp from './icons/chevron_right_18dp.svg?react';
import chevron_right_24dp from './icons/chevron_right_24dp.svg?react';
import chevron_up_18dp from './icons/chevron_up_18dp.svg?react';
import chevron_up_24dp from './icons/chevron_up_24dp.svg?react';
import circle_18dp from './icons/circle_18dp.svg?react';
import circle_24dp from './icons/circle_24dp.svg?react';
import circle_outline_18dp from './icons/circle_outline_18dp.svg?react';
import circle_outline_24dp from './icons/circle_outline_24dp.svg?react';
import clear_18dp from './icons/clear_18dp.svg?react';
import clear_24dp from './icons/clear_24dp.svg?react';
import clear_outline_18dp from './icons/clear_outline_18dp.svg?react';
import clear_outline_24dp from './icons/clear_outline_24dp.svg?react';
import close_18dp from './icons/close_18dp.svg?react';
import close_24dp from './icons/close_24dp.svg?react';
import cloud_18dp from './icons/cloud_18dp.svg?react';
import cloud_24dp from './icons/cloud_24dp.svg?react';
import cloud_off_18dp from './icons/cloud_off_18dp.svg?react';
import cloud_off_24dp from './icons/cloud_off_24dp.svg?react';
import cloud_sync_18dp from './icons/cloud_sync_18dp.svg?react';
import cloud_sync_24dp from './icons/cloud_sync_24dp.svg?react';
import compass_18dp from './icons/compass_18dp.svg?react';
import compass_24dp from './icons/compass_24dp.svg?react';
import content_copy_18dp from './icons/content_copy_18dp.svg?react';
import content_copy_24dp from './icons/content_copy_24dp.svg?react';
import dashboard_18dp from './icons/dashboard_18dp.svg?react';
import dashboard_24dp from './icons/dashboard_24dp.svg?react';
import dashboard_outline_18dp from './icons/dashboard_outline_18dp.svg?react';
import dashboard_outline_24dp from './icons/dashboard_outline_24dp.svg?react';
import date_range_18dp from './icons/date_range_18dp.svg?react';
import date_range_24dp from './icons/date_range_24dp.svg?react';
import delete_outline_18dp from './icons/delete_outline_18dp.svg?react';
import delete_outline_24dp from './icons/delete_outline_24dp.svg?react';
import destination_arrow_18dp from './icons/destination_arrow_18dp.svg?react';
import destination_arrow_24dp from './icons/destination_arrow_24dp.svg?react';
import directions_18dp from './icons/directions_18dp.svg?react';
import directions_24dp from './icons/directions_24dp.svg?react';
import directions_boat_18dp from './icons/directions_boat_18dp.svg?react';
import directions_boat_24dp from './icons/directions_boat_24dp.svg?react';
import directions_boat_outline_18dp from './icons/directions_boat_outline_18dp.svg?react';
import directions_boat_outline_24dp from './icons/directions_boat_outline_24dp.svg?react';
import directions_bus_18dp from './icons/directions_bus_18dp.svg?react';
import directions_bus_24dp from './icons/directions_bus_24dp.svg?react';
import directions_bus_outline_18dp from './icons/directions_bus_outline_18dp.svg?react';
import directions_bus_outline_24dp from './icons/directions_bus_outline_24dp.svg?react';
import directions_car_18dp from './icons/directions_car_18dp.svg?react';
import directions_car_24dp from './icons/directions_car_24dp.svg?react';
import directions_car_outline_18dp from './icons/directions_car_outline_18dp.svg?react';
import directions_car_outline_24dp from './icons/directions_car_outline_24dp.svg?react';
import directions_outline_18dp from './icons/directions_outline_18dp.svg?react';
import directions_outline_24dp from './icons/directions_outline_24dp.svg?react';
import directions_train_18dp from './icons/directions_train_18dp.svg?react';
import directions_train_24dp from './icons/directions_train_24dp.svg?react';
import directions_train_outline_18dp from './icons/directions_train_outline_18dp.svg?react';
import directions_train_outline_24dp from './icons/directions_train_outline_24dp.svg?react';
import directions_walk_18dp from './icons/directions_walk_18dp.svg?react';
import directions_walk_24dp from './icons/directions_walk_24dp.svg?react';
import directory_18dp from './icons/directory_18dp.svg?react';
import directory_24dp from './icons/directory_24dp.svg?react';
import directory_outline_18dp from './icons/directory_outline_18dp.svg?react';
import directory_outline_24dp from './icons/directory_outline_24dp.svg?react';
import do_not_18dp from './icons/do_not_18dp.svg?react';
import do_not_24dp from './icons/do_not_24dp.svg?react';
import drag_handle_18dp from './icons/drag_handle_18dp.svg?react';
import drag_handle_24dp from './icons/drag_handle_24dp.svg?react';
import drag_indicator_18dp from './icons/drag_indicator_18dp.svg?react';
import drag_indicator_24dp from './icons/drag_indicator_24dp.svg?react';
import edit_18dp from './icons/edit_18dp.svg?react';
import edit_24dp from './icons/edit_24dp.svg?react';
import edit_outline_18dp from './icons/edit_outline_18dp.svg?react';
import edit_outline_24dp from './icons/edit_outline_24dp.svg?react';
import emoji_emotions_18dp from './icons/emoji_emotions_18dp.svg?react';
import emoji_emotions_24dp from './icons/emoji_emotions_24dp.svg?react';
import emoji_emotions_outline_18dp from './icons/emoji_emotions_outline_18dp.svg?react';
import emoji_emotions_outline_24dp from './icons/emoji_emotions_outline_24dp.svg?react';
import entrance_18dp from './icons/entrance_18dp.svg?react';
import entrance_24dp from './icons/entrance_24dp.svg?react';
import error_18dp from './icons/error_18dp.svg?react';
import error_24dp from './icons/error_24dp.svg?react';
import error_outline_18dp from './icons/error_outline_18dp.svg?react';
import error_outline_24dp from './icons/error_outline_24dp.svg?react';
import escalator_18dp from './icons/escalator_18dp.svg?react';
import escalator_24dp from './icons/escalator_24dp.svg?react';
import extension_18dp from './icons/extension_18dp.svg?react';
import extension_24dp from './icons/extension_24dp.svg?react';
import extension_off_18dp from './icons/extension_off_18dp.svg?react';
import extension_off_24dp from './icons/extension_off_24dp.svg?react';
import feedback_18dp from './icons/feedback_18dp.svg?react';
import feedback_24dp from './icons/feedback_24dp.svg?react';
import feedback_outline_18dp from './icons/feedback_outline_18dp.svg?react';
import feedback_outline_24dp from './icons/feedback_outline_24dp.svg?react';
import file_18dp from './icons/file_18dp.svg?react';
import file_24dp from './icons/file_24dp.svg?react';
import file_download_18dp from './icons/file_download_18dp.svg?react';
import file_download_24dp from './icons/file_download_24dp.svg?react';
import file_outline_18dp from './icons/file_outline_18dp.svg?react';
import file_outline_24dp from './icons/file_outline_24dp.svg?react';
import file_upload_18dp from './icons/file_upload_18dp.svg?react';
import file_upload_24dp from './icons/file_upload_24dp.svg?react';
import filter_alt_18dp from './icons/filter_alt_18dp.svg?react';
import filter_alt_24dp from './icons/filter_alt_24dp.svg?react';
import filter_list_18dp from './icons/filter_list_18dp.svg?react';
import filter_list_24dp from './icons/filter_list_24dp.svg?react';
import flag_18dp from './icons/flag_18dp.svg?react';
import flag_24dp from './icons/flag_24dp.svg?react';
import flag_outline_18dp from './icons/flag_outline_18dp.svg?react';
import flag_outline_24dp from './icons/flag_outline_24dp.svg?react';
import flight_18dp from './icons/flight_18dp.svg?react';
import flight_24dp from './icons/flight_24dp.svg?react';
import flight_land_18dp from './icons/flight_land_18dp.svg?react';
import flight_land_24dp from './icons/flight_land_24dp.svg?react';
import flight_takeoff_18dp from './icons/flight_takeoff_18dp.svg?react';
import flight_takeoff_24dp from './icons/flight_takeoff_24dp.svg?react';
import folder_18dp from './icons/folder_18dp.svg?react';
import folder_24dp from './icons/folder_24dp.svg?react';
import folder_open_18dp from './icons/folder_open_18dp.svg?react';
import folder_open_24dp from './icons/folder_open_24dp.svg?react';
import folder_outline_18dp from './icons/folder_outline_18dp.svg?react';
import folder_outline_24dp from './icons/folder_outline_24dp.svg?react';
import form_stretch_24dp from './icons/form_stretch_24dp.svg?react';
import format_list_bulleted_18dp from './icons/format_list_bulleted_18dp.svg?react';
import format_list_bulleted_24dp from './icons/format_list_bulleted_24dp.svg?react';
import forward_18dp from './icons/forward_18dp.svg?react';
import forward_24dp from './icons/forward_24dp.svg?react';
import fullscreen_18dp from './icons/fullscreen_18dp.svg?react';
import fullscreen_24dp from './icons/fullscreen_24dp.svg?react';
import group_18dp from './icons/group_18dp.svg?react';
import group_24dp from './icons/group_24dp.svg?react';
import group_outline_18dp from './icons/group_outline_18dp.svg?react';
import group_outline_24dp from './icons/group_outline_24dp.svg?react';
import groups_18dp from './icons/groups_18dp.svg?react';
import groups_24dp from './icons/groups_24dp.svg?react';
import gyroscope_18dp from './icons/gyroscope_18dp.svg?react';
import gyroscope_24dp from './icons/gyroscope_24dp.svg?react';
import hand_18dp from './icons/hand_18dp.svg?react';
import hand_24dp from './icons/hand_24dp.svg?react';
import hand_outline_18dp from './icons/hand_outline_18dp.svg?react';
import hand_outline_24dp from './icons/hand_outline_24dp.svg?react';
import help_18dp from './icons/help_18dp.svg?react';
import help_24dp from './icons/help_24dp.svg?react';
import help_outline_18dp from './icons/help_outline_18dp.svg?react';
import help_outline_24dp from './icons/help_outline_24dp.svg?react';
import hide_image_18dp from './icons/hide_image_18dp.svg?react';
import hide_image_24dp from './icons/hide_image_24dp.svg?react';
import high_priority_18dp from './icons/high_priority_18dp.svg?react';
import high_priority_24dp from './icons/high_priority_24dp.svg?react';
import history_18dp from './icons/history_18dp.svg?react';
import history_24dp from './icons/history_24dp.svg?react';
import home_18dp from './icons/home_18dp.svg?react';
import home_24dp from './icons/home_24dp.svg?react';
import home_outline_18dp from './icons/home_outline_18dp.svg?react';
import home_outline_24dp from './icons/home_outline_24dp.svg?react';
import hours_18dp from './icons/hours_18dp.svg?react';
import hours_24dp from './icons/hours_24dp.svg?react';
import hours_outline_18dp from './icons/hours_outline_18dp.svg?react';
import hours_outline_24dp from './icons/hours_outline_24dp.svg?react';
import image_18dp from './icons/image_18dp.svg?react';
import image_24dp from './icons/image_24dp.svg?react';
import image_outline_18dp from './icons/image_outline_18dp.svg?react';
import image_outline_24dp from './icons/image_outline_24dp.svg?react';
import import_export_18dp from './icons/import_export_18dp.svg?react';
import import_export_24dp from './icons/import_export_24dp.svg?react';
import indeterminate_check_box_24dp from './icons/indeterminate_check_box_24dp.svg?react';
import indeterminate_check_box_outline_24dp from './icons/indeterminate_check_box_outline_24dp.svg?react';
import info_18dp from './icons/info_18dp.svg?react';
import info_24dp from './icons/info_24dp.svg?react';
import info_outline_18dp from './icons/info_outline_18dp.svg?react';
import info_outline_24dp from './icons/info_outline_24dp.svg?react';
import insert_invitation_18dp from './icons/insert_invitation_18dp.svg?react';
import insert_invitation_24dp from './icons/insert_invitation_24dp.svg?react';
import insights_18dp from './icons/insights_18dp.svg?react';
import insights_24dp from './icons/insights_24dp.svg?react';
import key_18dp from './icons/key_18dp.svg?react';
import key_24dp from './icons/key_24dp.svg?react';
import label_18dp from './icons/label_18dp.svg?react';
import label_24dp from './icons/label_24dp.svg?react';
import label_outline_18dp from './icons/label_outline_18dp.svg?react';
import label_outline_24dp from './icons/label_outline_24dp.svg?react';
import language_18dp from './icons/language_18dp.svg?react';
import language_24dp from './icons/language_24dp.svg?react';
import launch_18dp from './icons/launch_18dp.svg?react';
import launch_24dp from './icons/launch_24dp.svg?react';
import layers_outline_18dp from './icons/layers_outline_18dp.svg?react';
import layers_outline_24dp from './icons/layers_outline_24dp.svg?react';
import levels_outline_18dp from './icons/levels_outline_18dp.svg?react';
import levels_outline_24dp from './icons/levels_outline_24dp.svg?react';
import lift_18dp from './icons/lift_18dp.svg?react';
import lift_24dp from './icons/lift_24dp.svg?react';
import lightbulb_18dp from './icons/lightbulb_18dp.svg?react';
import lightbulb_24dp from './icons/lightbulb_24dp.svg?react';
import link_18dp from './icons/link_18dp.svg?react';
import link_24dp from './icons/link_24dp.svg?react';
import list_alt_18dp from './icons/list_alt_18dp.svg?react';
import list_alt_24dp from './icons/list_alt_24dp.svg?react';
import live_12dp from './icons/live_12dp.svg?react';
import lm_logomark_24dp from './icons/lm_logomark_24dp.svg?react';
import local_shipping_18dp from './icons/local_shipping_18dp.svg?react';
import local_shipping_24dp from './icons/local_shipping_24dp.svg?react';
import location_18dp from './icons/location_18dp.svg?react';
import location_24dp from './icons/location_24dp.svg?react';
import location_disabled_18dp from './icons/location_disabled_18dp.svg?react';
import location_disabled_24dp from './icons/location_disabled_24dp.svg?react';
import location_off_18dp from './icons/location_off_18dp.svg?react';
import location_off_24dp from './icons/location_off_24dp.svg?react';
import location_off_outline_18dp from './icons/location_off_outline_18dp.svg?react';
import location_off_outline_24dp from './icons/location_off_outline_24dp.svg?react';
import location_on_18dp from './icons/location_on_18dp.svg?react';
import location_on_24dp from './icons/location_on_24dp.svg?react';
import location_on_outline_18dp from './icons/location_on_outline_18dp.svg?react';
import location_on_outline_24dp from './icons/location_on_outline_24dp.svg?react';
import location_outline_18dp from './icons/location_outline_18dp.svg?react';
import location_outline_24dp from './icons/location_outline_24dp.svg?react';
import location_searching_18dp from './icons/location_searching_18dp.svg?react';
import location_searching_24dp from './icons/location_searching_24dp.svg?react';
import lock_18dp from './icons/lock_18dp.svg?react';
import lock_24dp from './icons/lock_24dp.svg?react';
import logout_18dp from './icons/logout_18dp.svg?react';
import logout_24dp from './icons/logout_24dp.svg?react';
import low_priority_18dp from './icons/low_priority_18dp.svg?react';
import low_priority_24dp from './icons/low_priority_24dp.svg?react';
import luggage_18dp from './icons/luggage_18dp.svg?react';
import luggage_24dp from './icons/luggage_24dp.svg?react';
import map_18dp from './icons/map_18dp.svg?react';
import map_24dp from './icons/map_24dp.svg?react';
import map_outline_18dp from './icons/map_outline_18dp.svg?react';
import map_outline_24dp from './icons/map_outline_24dp.svg?react';
import menu_18dp from './icons/menu_18dp.svg?react';
import menu_24dp from './icons/menu_24dp.svg?react';
import menu_alt_18dp from './icons/menu_alt_18dp.svg?react';
import menu_alt_24dp from './icons/menu_alt_24dp.svg?react';
import minus_18dp from './icons/minus_18dp.svg?react';
import minus_24dp from './icons/minus_24dp.svg?react';
import more_horiz_18dp from './icons/more_horiz_18dp.svg?react';
import more_horiz_24dp from './icons/more_horiz_24dp.svg?react';
import more_vert_18dp from './icons/more_vert_18dp.svg?react';
import more_vert_24dp from './icons/more_vert_24dp.svg?react';
import multiline_chart_18dp from './icons/multiline_chart_18dp.svg?react';
import multiline_chart_24dp from './icons/multiline_chart_24dp.svg?react';
import my_location_18dp from './icons/my_location_18dp.svg?react';
import my_location_24dp from './icons/my_location_24dp.svg?react';
import navigation_18dp from './icons/navigation_18dp.svg?react';
import navigation_24dp from './icons/navigation_24dp.svg?react';
import navigation_outline_18dp from './icons/navigation_outline_18dp.svg?react';
import navigation_outline_24dp from './icons/navigation_outline_24dp.svg?react';
import near_me_18dp from './icons/near_me_18dp.svg?react';
import near_me_24dp from './icons/near_me_24dp.svg?react';
import near_me_disabled_18dp from './icons/near_me_disabled_18dp.svg?react';
import near_me_disabled_24dp from './icons/near_me_disabled_24dp.svg?react';
import near_me_disabled_outline_18dp from './icons/near_me_disabled_outline_18dp.svg?react';
import near_me_disabled_outline_24dp from './icons/near_me_disabled_outline_24dp.svg?react';
import near_me_outline_18dp from './icons/near_me_outline_18dp.svg?react';
import near_me_outline_24dp from './icons/near_me_outline_24dp.svg?react';
import near_me_sparkle_18dp from './icons/near_me_sparkle_18dp.svg?react';
import near_me_sparkle_24dp from './icons/near_me_sparkle_24dp.svg?react';
import near_me_sparkle_outline_18dp from './icons/near_me_sparkle_outline_18dp.svg?react';
import near_me_sparkle_outline_24dp from './icons/near_me_sparkle_outline_24dp.svg?react';
import new_releases_18dp from './icons/new_releases_18dp.svg?react';
import new_releases_24dp from './icons/new_releases_24dp.svg?react';
import new_releases_outline_18dp from './icons/new_releases_outline_18dp.svg?react';
import new_releases_outline_24dp from './icons/new_releases_outline_24dp.svg?react';
import no_icon_18dp from './icons/no_icon_18dp.svg?react';
import no_icon_24dp from './icons/no_icon_24dp.svg?react';
import open_in_new_18dp from './icons/open_in_new_18dp.svg?react';
import open_in_new_24dp from './icons/open_in_new_24dp.svg?react';
import open_in_new_alt_18dp from './icons/open_in_new_alt_18dp.svg?react';
import open_in_new_alt_24dp from './icons/open_in_new_alt_24dp.svg?react';
import origin_arrow_18dp from './icons/origin_arrow_18dp.svg?react';
import origin_arrow_24dp from './icons/origin_arrow_24dp.svg?react';
import pedal_bike_18dp from './icons/pedal_bike_18dp.svg?react';
import pedal_bike_24dp from './icons/pedal_bike_24dp.svg?react';
import pending_18dp from './icons/pending_18dp.svg?react';
import pending_24dp from './icons/pending_24dp.svg?react';
import pending_outline_18dp from './icons/pending_outline_18dp.svg?react';
import pending_outline_24dp from './icons/pending_outline_24dp.svg?react';
import people_18dp from './icons/people_18dp.svg?react';
import people_24dp from './icons/people_24dp.svg?react';
import people_outline_18dp from './icons/people_outline_18dp.svg?react';
import people_outline_24dp from './icons/people_outline_24dp.svg?react';
import person_18dp from './icons/person_18dp.svg?react';
import person_24dp from './icons/person_24dp.svg?react';
import person_outline_18dp from './icons/person_outline_18dp.svg?react';
import person_outline_24dp from './icons/person_outline_24dp.svg?react';
import perspective_2d_18dp from './icons/perspective_2d_18dp.svg?react';
import perspective_2d_24dp from './icons/perspective_2d_24dp.svg?react';
import perspective_3d_18dp from './icons/perspective_3d_18dp.svg?react';
import perspective_3d_24dp from './icons/perspective_3d_24dp.svg?react';
import phone_18dp from './icons/phone_18dp.svg?react';
import phone_24dp from './icons/phone_24dp.svg?react';
import phone_outline_18dp from './icons/phone_outline_18dp.svg?react';
import phone_outline_24dp from './icons/phone_outline_24dp.svg?react';
import photo_library_18dp from './icons/photo_library_18dp.svg?react';
import photo_library_24dp from './icons/photo_library_24dp.svg?react';
import placeholder_icon_18dp from './icons/placeholder_icon_18dp.svg?react';
import placeholder_icon_24dp from './icons/placeholder_icon_24dp.svg?react';
import play_arrow_18dp from './icons/play_arrow_18dp.svg?react';
import play_arrow_24dp from './icons/play_arrow_24dp.svg?react';
import play_circle_18dp from './icons/play_circle_18dp.svg?react';
import play_circle_24dp from './icons/play_circle_24dp.svg?react';
import play_circle_outline_18dp from './icons/play_circle_outline_18dp.svg?react';
import play_circle_outline_24dp from './icons/play_circle_outline_24dp.svg?react';
import plus_18dp from './icons/plus_18dp.svg?react';
import plus_24dp from './icons/plus_24dp.svg?react';
import point_18dp from './icons/point_18dp.svg?react';
import point_24dp from './icons/point_24dp.svg?react';
import public_transport_24dp from './icons/public_transport_24dp.svg?react';
import qr_code_18dp from './icons/qr_code_18dp.svg?react';
import qr_code_24dp from './icons/qr_code_24dp.svg?react';
import qr_code_outline_18dp from './icons/qr_code_outline_18dp.svg?react';
import qr_code_outline_24dp from './icons/qr_code_outline_24dp.svg?react';
import query_stats_18dp from './icons/query_stats_18dp.svg?react';
import query_stats_24dp from './icons/query_stats_24dp.svg?react';
import radio_button_checked_24dp from './icons/radio_button_checked_24dp.svg?react';
import radio_button_checked_outline_24dp from './icons/radio_button_checked_outline_24dp.svg?react';
import radio_button_unchecked_24dp from './icons/radio_button_unchecked_24dp.svg?react';
import radio_button_unchecked_outline_24dp from './icons/radio_button_unchecked_outline_24dp.svg?react';
import redo_18dp from './icons/redo_18dp.svg?react';
import redo_24dp from './icons/redo_24dp.svg?react';
import refresh_18dp from './icons/refresh_18dp.svg?react';
import refresh_24dp from './icons/refresh_24dp.svg?react';
import remove_circle_18dp from './icons/remove_circle_18dp.svg?react';
import remove_circle_24dp from './icons/remove_circle_24dp.svg?react';
import remove_circle_outline_18dp from './icons/remove_circle_outline_18dp.svg?react';
import remove_circle_outline_24dp from './icons/remove_circle_outline_24dp.svg?react';
import replay_18dp from './icons/replay_18dp.svg?react';
import replay_24dp from './icons/replay_24dp.svg?react';
import restaurant_menu_18dp from './icons/restaurant_menu_18dp.svg?react';
import restaurant_menu_24dp from './icons/restaurant_menu_24dp.svg?react';
import route_18dp from './icons/route_18dp.svg?react';
import route_24dp from './icons/route_24dp.svg?react';
import route_end_24dp from './icons/route_end_24dp.svg?react';
import route_start_24dp from './icons/route_start_24dp.svg?react';
import route_user_location_24dp from './icons/route_user_location_24dp.svg?react';
import save_18dp from './icons/save_18dp.svg?react';
import save_24dp from './icons/save_24dp.svg?react';
import save_alt_18dp from './icons/save_alt_18dp.svg?react';
import save_alt_24dp from './icons/save_alt_24dp.svg?react';
import search_18dp from './icons/search_18dp.svg?react';
import search_24dp from './icons/search_24dp.svg?react';
import security_18dp from './icons/security_18dp.svg?react';
import security_24dp from './icons/security_24dp.svg?react';
import security_guard_18dp from './icons/security_guard_18dp.svg?react';
import security_guard_24dp from './icons/security_guard_24dp.svg?react';
import security_guard_outline_18dp from './icons/security_guard_outline_18dp.svg?react';
import security_guard_outline_24dp from './icons/security_guard_outline_24dp.svg?react';
import send_to_mobile_18dp from './icons/send_to_mobile_18dp.svg?react';
import send_to_mobile_24dp from './icons/send_to_mobile_24dp.svg?react';
import send_to_mobile_outline_18dp from './icons/send_to_mobile_outline_18dp.svg?react';
import send_to_mobile_outline_24dp from './icons/send_to_mobile_outline_24dp.svg?react';
import settings_18dp from './icons/settings_18dp.svg?react';
import settings_24dp from './icons/settings_24dp.svg?react';
import share_18dp from './icons/share_18dp.svg?react';
import share_24dp from './icons/share_24dp.svg?react';
import signpost_18dp from './icons/signpost_18dp.svg?react';
import signpost_24dp from './icons/signpost_24dp.svg?react';
import signpost_outline_18dp from './icons/signpost_outline_18dp.svg?react';
import signpost_outline_24dp from './icons/signpost_outline_24dp.svg?react';
import stairs_18dp from './icons/stairs_18dp.svg?react';
import stairs_24dp from './icons/stairs_24dp.svg?react';
import star_18dp from './icons/star_18dp.svg?react';
import star_24dp from './icons/star_24dp.svg?react';
import subway_18dp from './icons/subway_18dp.svg?react';
import subway_24dp from './icons/subway_24dp.svg?react';
import subway_outline_18dp from './icons/subway_outline_18dp.svg?react';
import subway_outline_24dp from './icons/subway_outline_24dp.svg?react';
import support_18dp from './icons/support_18dp.svg?react';
import support_24dp from './icons/support_24dp.svg?react';
import support_agent_18dp from './icons/support_agent_18dp.svg?react';
import support_agent_24dp from './icons/support_agent_24dp.svg?react';
import swap_vert_18dp from './icons/swap_vert_18dp.svg?react';
import swap_vert_24dp from './icons/swap_vert_24dp.svg?react';
import sync_18dp from './icons/sync_18dp.svg?react';
import sync_24dp from './icons/sync_24dp.svg?react';
import sync_alt_18dp from './icons/sync_alt_18dp.svg?react';
import sync_alt_24dp from './icons/sync_alt_24dp.svg?react';
import sync_disabled_18dp from './icons/sync_disabled_18dp.svg?react';
import sync_disabled_24dp from './icons/sync_disabled_24dp.svg?react';
import sync_problem_18dp from './icons/sync_problem_18dp.svg?react';
import sync_problem_24dp from './icons/sync_problem_24dp.svg?react';
import table_18dp from './icons/table_18dp.svg?react';
import table_24dp from './icons/table_24dp.svg?react';
import taxi_18dp from './icons/taxi_18dp.svg?react';
import taxi_24dp from './icons/taxi_24dp.svg?react';
import taxi_outline_18dp from './icons/taxi_outline_18dp.svg?react';
import taxi_outline_24dp from './icons/taxi_outline_24dp.svg?react';
import ticket_18dp from './icons/ticket_18dp.svg?react';
import ticket_24dp from './icons/ticket_24dp.svg?react';
import timer_18dp from './icons/timer_18dp.svg?react';
import timer_24dp from './icons/timer_24dp.svg?react';
import timer_outline_18dp from './icons/timer_outline_18dp.svg?react';
import timer_outline_24dp from './icons/timer_outline_24dp.svg?react';
import today_18dp from './icons/today_18dp.svg?react';
import today_24dp from './icons/today_24dp.svg?react';
import today_outline_18dp from './icons/today_outline_18dp.svg?react';
import today_outline_24dp from './icons/today_outline_24dp.svg?react';
import tram_18dp from './icons/tram_18dp.svg?react';
import tram_24dp from './icons/tram_24dp.svg?react';
import tram_outline_18dp from './icons/tram_outline_18dp.svg?react';
import tram_outline_24dp from './icons/tram_outline_24dp.svg?react';
import translate_18dp from './icons/translate_18dp.svg?react';
import translate_24dp from './icons/translate_24dp.svg?react';
import trending_up_18dp from './icons/trending_up_18dp.svg?react';
import trending_up_24dp from './icons/trending_up_24dp.svg?react';
import tune_18dp from './icons/tune_18dp.svg?react';
import tune_24dp from './icons/tune_24dp.svg?react';
import undo_18dp from './icons/undo_18dp.svg?react';
import undo_24dp from './icons/undo_24dp.svg?react';
import unfold_more_18dp from './icons/unfold_more_18dp.svg?react';
import unfold_more_24dp from './icons/unfold_more_24dp.svg?react';
import update_18dp from './icons/update_18dp.svg?react';
import update_24dp from './icons/update_24dp.svg?react';
import view_360_18dp from './icons/view_360_18dp.svg?react';
import view_360_24dp from './icons/view_360_24dp.svg?react';
import visibility_off_18dp from './icons/visibility_off_18dp.svg?react';
import visibility_off_24dp from './icons/visibility_off_24dp.svg?react';
import visibility_off_outline_18dp from './icons/visibility_off_outline_18dp.svg?react';
import visibility_off_outline_24dp from './icons/visibility_off_outline_24dp.svg?react';
import visibility_on_18dp from './icons/visibility_on_18dp.svg?react';
import visibility_on_24dp from './icons/visibility_on_24dp.svg?react';
import visibility_outline_18dp from './icons/visibility_outline_18dp.svg?react';
import visibility_outline_24dp from './icons/visibility_outline_24dp.svg?react';
import warning_18dp from './icons/warning_18dp.svg?react';
import warning_24dp from './icons/warning_24dp.svg?react';
import warning_outline_18dp from './icons/warning_outline_18dp.svg?react';
import warning_outline_24dp from './icons/warning_outline_24dp.svg?react';
import website_18dp from './icons/website_18dp.svg?react';
import website_24dp from './icons/website_24dp.svg?react';
import whatshot_18dp from './icons/whatshot_18dp.svg?react';
import whatshot_24dp from './icons/whatshot_24dp.svg?react';
import whatshot_outline_18dp from './icons/whatshot_outline_18dp.svg?react';
import whatshot_outline_24dp from './icons/whatshot_outline_24dp.svg?react';
import widgets_18dp from './icons/widgets_18dp.svg?react';
import widgets_24dp from './icons/widgets_24dp.svg?react';
import wifi_18dp from './icons/wifi_18dp.svg?react';
import wifi_24dp from './icons/wifi_24dp.svg?react';
import wifi_off_18dp from './icons/wifi_off_18dp.svg?react';
import wifi_off_24dp from './icons/wifi_off_24dp.svg?react';

const icons = {
  accessible_18dp,
  accessible_24dp,
  account_circle_18dp,
  account_circle_24dp,
  account_circle_outline_18dp,
  account_circle_outline_24dp,
  add_circle_18dp,
  add_circle_24dp,
  add_circle_outline_18dp,
  add_circle_outline_24dp,
  add_image_18dp,
  add_image_24dp,
  add_image_outline_18dp,
  add_image_outline_24dp,
  add_location_18dp,
  add_location_24dp,
  arrow_back_18dp,
  arrow_back_24dp,
  arrow_downward_18dp,
  arrow_downward_24dp,
  arrow_forward_18dp,
  arrow_forward_24dp,
  arrow_upward_18dp,
  arrow_upward_24dp,
  back_18dp,
  back_24dp,
  backspace_18dp,
  backspace_24dp,
  badge_18dp,
  badge_24dp,
  badge_outline_18dp,
  badge_outline_24dp,
  bar_chart_18dp,
  bar_chart_24dp,
  build_circle_18dp,
  build_circle_24dp,
  building_18dp,
  building_24dp,
  calendar_month_18dp,
  calendar_month_24dp,
  calendar_month_outline_18dp,
  calendar_month_outline_24dp,
  calendar_today_18dp,
  calendar_today_24dp,
  calendar_today_outline_18dp,
  calendar_today_outline_24dp,
  category_18dp,
  category_24dp,
  chat_bubble_18dp,
  chat_bubble_24dp,
  chat_bubble_outline_18dp,
  chat_bubble_outline_24dp,
  check_18dp,
  check_24dp,
  check_box_24dp,
  check_box_outline_24dp,
  check_box_unchecked_24dp,
  check_box_unchecked_outline_24dp,
  check_circle_18dp,
  check_circle_24dp,
  check_circle_outline_18dp,
  check_circle_outline_24dp,
  chevron_down_18dp,
  chevron_down_24dp,
  chevron_left_18dp,
  chevron_left_24dp,
  chevron_right_18dp,
  chevron_right_24dp,
  chevron_up_18dp,
  chevron_up_24dp,
  circle_18dp,
  circle_24dp,
  circle_outline_18dp,
  circle_outline_24dp,
  clear_18dp,
  clear_24dp,
  clear_outline_18dp,
  clear_outline_24dp,
  close_18dp,
  close_24dp,
  cloud_18dp,
  cloud_24dp,
  cloud_off_18dp,
  cloud_off_24dp,
  cloud_sync_18dp,
  cloud_sync_24dp,
  compass_18dp,
  compass_24dp,
  content_copy_18dp,
  content_copy_24dp,
  dashboard_18dp,
  dashboard_24dp,
  dashboard_outline_18dp,
  dashboard_outline_24dp,
  date_range_18dp,
  date_range_24dp,
  delete_outline_18dp,
  delete_outline_24dp,
  destination_arrow_18dp,
  destination_arrow_24dp,
  directions_18dp,
  directions_24dp,
  directions_boat_18dp,
  directions_boat_24dp,
  directions_boat_outline_18dp,
  directions_boat_outline_24dp,
  directions_bus_18dp,
  directions_bus_24dp,
  directions_bus_outline_18dp,
  directions_bus_outline_24dp,
  directions_car_18dp,
  directions_car_24dp,
  directions_car_outline_18dp,
  directions_car_outline_24dp,
  directions_outline_18dp,
  directions_outline_24dp,
  directions_train_18dp,
  directions_train_24dp,
  directions_train_outline_18dp,
  directions_train_outline_24dp,
  directions_walk_18dp,
  directions_walk_24dp,
  directory_18dp,
  directory_24dp,
  directory_outline_18dp,
  directory_outline_24dp,
  do_not_18dp,
  do_not_24dp,
  drag_handle_18dp,
  drag_handle_24dp,
  drag_indicator_18dp,
  drag_indicator_24dp,
  edit_18dp,
  edit_24dp,
  edit_outline_18dp,
  edit_outline_24dp,
  emoji_emotions_18dp,
  emoji_emotions_24dp,
  emoji_emotions_outline_18dp,
  emoji_emotions_outline_24dp,
  entrance_18dp,
  entrance_24dp,
  error_18dp,
  error_24dp,
  error_outline_18dp,
  error_outline_24dp,
  escalator_18dp,
  escalator_24dp,
  extension_18dp,
  extension_24dp,
  extension_off_18dp,
  extension_off_24dp,
  feedback_18dp,
  feedback_24dp,
  feedback_outline_18dp,
  feedback_outline_24dp,
  file_18dp,
  file_24dp,
  file_download_18dp,
  file_download_24dp,
  file_outline_18dp,
  file_outline_24dp,
  file_upload_18dp,
  file_upload_24dp,
  filter_alt_18dp,
  filter_alt_24dp,
  filter_list_18dp,
  filter_list_24dp,
  flag_18dp,
  flag_24dp,
  flag_outline_18dp,
  flag_outline_24dp,
  flight_18dp,
  flight_24dp,
  flight_land_18dp,
  flight_land_24dp,
  flight_takeoff_18dp,
  flight_takeoff_24dp,
  folder_18dp,
  folder_24dp,
  folder_open_18dp,
  folder_open_24dp,
  folder_outline_18dp,
  folder_outline_24dp,
  form_stretch_24dp,
  format_list_bulleted_18dp,
  format_list_bulleted_24dp,
  forward_18dp,
  forward_24dp,
  fullscreen_18dp,
  fullscreen_24dp,
  group_18dp,
  group_24dp,
  group_outline_18dp,
  group_outline_24dp,
  groups_18dp,
  groups_24dp,
  gyroscope_18dp,
  gyroscope_24dp,
  hand_18dp,
  hand_24dp,
  hand_outline_18dp,
  hand_outline_24dp,
  help_18dp,
  help_24dp,
  help_outline_18dp,
  help_outline_24dp,
  hide_image_18dp,
  hide_image_24dp,
  high_priority_18dp,
  high_priority_24dp,
  history_18dp,
  history_24dp,
  home_18dp,
  home_24dp,
  home_outline_18dp,
  home_outline_24dp,
  hours_18dp,
  hours_24dp,
  hours_outline_18dp,
  hours_outline_24dp,
  image_18dp,
  image_24dp,
  image_outline_18dp,
  image_outline_24dp,
  import_export_18dp,
  import_export_24dp,
  indeterminate_check_box_24dp,
  indeterminate_check_box_outline_24dp,
  info_18dp,
  info_24dp,
  info_outline_18dp,
  info_outline_24dp,
  insert_invitation_18dp,
  insert_invitation_24dp,
  insights_18dp,
  insights_24dp,
  key_18dp,
  key_24dp,
  label_18dp,
  label_24dp,
  label_outline_18dp,
  label_outline_24dp,
  language_18dp,
  language_24dp,
  launch_18dp,
  launch_24dp,
  layers_outline_18dp,
  layers_outline_24dp,
  levels_outline_18dp,
  levels_outline_24dp,
  lift_18dp,
  lift_24dp,
  lightbulb_18dp,
  lightbulb_24dp,
  link_18dp,
  link_24dp,
  list_alt_18dp,
  list_alt_24dp,
  live_12dp,
  lm_logomark_24dp,
  local_shipping_18dp,
  local_shipping_24dp,
  location_18dp,
  location_24dp,
  location_disabled_18dp,
  location_disabled_24dp,
  location_off_18dp,
  location_off_24dp,
  location_off_outline_18dp,
  location_off_outline_24dp,
  location_on_18dp,
  location_on_24dp,
  location_on_outline_18dp,
  location_on_outline_24dp,
  location_outline_18dp,
  location_outline_24dp,
  location_searching_18dp,
  location_searching_24dp,
  lock_18dp,
  lock_24dp,
  logout_18dp,
  logout_24dp,
  low_priority_18dp,
  low_priority_24dp,
  luggage_18dp,
  luggage_24dp,
  map_18dp,
  map_24dp,
  map_outline_18dp,
  map_outline_24dp,
  menu_18dp,
  menu_24dp,
  menu_alt_18dp,
  menu_alt_24dp,
  minus_18dp,
  minus_24dp,
  more_horiz_18dp,
  more_horiz_24dp,
  more_vert_18dp,
  more_vert_24dp,
  multiline_chart_18dp,
  multiline_chart_24dp,
  my_location_18dp,
  my_location_24dp,
  navigation_18dp,
  navigation_24dp,
  navigation_outline_18dp,
  navigation_outline_24dp,
  near_me_18dp,
  near_me_24dp,
  near_me_disabled_18dp,
  near_me_disabled_24dp,
  near_me_disabled_outline_18dp,
  near_me_disabled_outline_24dp,
  near_me_outline_18dp,
  near_me_outline_24dp,
  near_me_sparkle_18dp,
  near_me_sparkle_24dp,
  near_me_sparkle_outline_18dp,
  near_me_sparkle_outline_24dp,
  new_releases_18dp,
  new_releases_24dp,
  new_releases_outline_18dp,
  new_releases_outline_24dp,
  no_icon_18dp,
  no_icon_24dp,
  open_in_new_18dp,
  open_in_new_24dp,
  open_in_new_alt_18dp,
  open_in_new_alt_24dp,
  origin_arrow_18dp,
  origin_arrow_24dp,
  pedal_bike_18dp,
  pedal_bike_24dp,
  pending_18dp,
  pending_24dp,
  pending_outline_18dp,
  pending_outline_24dp,
  people_18dp,
  people_24dp,
  people_outline_18dp,
  people_outline_24dp,
  person_18dp,
  person_24dp,
  person_outline_18dp,
  person_outline_24dp,
  perspective_2d_18dp,
  perspective_2d_24dp,
  perspective_3d_18dp,
  perspective_3d_24dp,
  phone_18dp,
  phone_24dp,
  phone_outline_18dp,
  phone_outline_24dp,
  photo_library_18dp,
  photo_library_24dp,
  placeholder_icon_18dp,
  placeholder_icon_24dp,
  play_arrow_18dp,
  play_arrow_24dp,
  play_circle_18dp,
  play_circle_24dp,
  play_circle_outline_18dp,
  play_circle_outline_24dp,
  plus_18dp,
  plus_24dp,
  point_18dp,
  point_24dp,
  public_transport_24dp,
  qr_code_18dp,
  qr_code_24dp,
  qr_code_outline_18dp,
  qr_code_outline_24dp,
  query_stats_18dp,
  query_stats_24dp,
  radio_button_checked_24dp,
  radio_button_checked_outline_24dp,
  radio_button_unchecked_24dp,
  radio_button_unchecked_outline_24dp,
  redo_18dp,
  redo_24dp,
  refresh_18dp,
  refresh_24dp,
  remove_circle_18dp,
  remove_circle_24dp,
  remove_circle_outline_18dp,
  remove_circle_outline_24dp,
  replay_18dp,
  replay_24dp,
  restaurant_menu_18dp,
  restaurant_menu_24dp,
  route_18dp,
  route_24dp,
  route_end_24dp,
  route_start_24dp,
  route_user_location_24dp,
  save_18dp,
  save_24dp,
  save_alt_18dp,
  save_alt_24dp,
  search_18dp,
  search_24dp,
  security_18dp,
  security_24dp,
  security_guard_18dp,
  security_guard_24dp,
  security_guard_outline_18dp,
  security_guard_outline_24dp,
  send_to_mobile_18dp,
  send_to_mobile_24dp,
  send_to_mobile_outline_18dp,
  send_to_mobile_outline_24dp,
  settings_18dp,
  settings_24dp,
  share_18dp,
  share_24dp,
  signpost_18dp,
  signpost_24dp,
  signpost_outline_18dp,
  signpost_outline_24dp,
  stairs_18dp,
  stairs_24dp,
  star_18dp,
  star_24dp,
  subway_18dp,
  subway_24dp,
  subway_outline_18dp,
  subway_outline_24dp,
  support_18dp,
  support_24dp,
  support_agent_18dp,
  support_agent_24dp,
  swap_vert_18dp,
  swap_vert_24dp,
  sync_18dp,
  sync_24dp,
  sync_alt_18dp,
  sync_alt_24dp,
  sync_disabled_18dp,
  sync_disabled_24dp,
  sync_problem_18dp,
  sync_problem_24dp,
  table_18dp,
  table_24dp,
  taxi_18dp,
  taxi_24dp,
  taxi_outline_18dp,
  taxi_outline_24dp,
  ticket_18dp,
  ticket_24dp,
  timer_18dp,
  timer_24dp,
  timer_outline_18dp,
  timer_outline_24dp,
  today_18dp,
  today_24dp,
  today_outline_18dp,
  today_outline_24dp,
  tram_18dp,
  tram_24dp,
  tram_outline_18dp,
  tram_outline_24dp,
  translate_18dp,
  translate_24dp,
  trending_up_18dp,
  trending_up_24dp,
  tune_18dp,
  tune_24dp,
  undo_18dp,
  undo_24dp,
  unfold_more_18dp,
  unfold_more_24dp,
  update_18dp,
  update_24dp,
  view_360_18dp,
  view_360_24dp,
  visibility_off_18dp,
  visibility_off_24dp,
  visibility_off_outline_18dp,
  visibility_off_outline_24dp,
  visibility_on_18dp,
  visibility_on_24dp,
  visibility_outline_18dp,
  visibility_outline_24dp,
  warning_18dp,
  warning_24dp,
  warning_outline_18dp,
  warning_outline_24dp,
  website_18dp,
  website_24dp,
  whatshot_18dp,
  whatshot_24dp,
  whatshot_outline_18dp,
  whatshot_outline_24dp,
  widgets_18dp,
  widgets_24dp,
  wifi_18dp,
  wifi_24dp,
  wifi_off_18dp,
  wifi_off_24dp,
};

export default icons;
